import React, { useState, useEffect } from 'react';
import './scss/style.scss';
import './css/style.css';
import './css/login.css';
import './css/custom.css';
import './css/theme.css';
//import './config/bootstrap.scss';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from 'react-bootstrap';
import VersionCheck from './components/VersionCheck';


/** pages */
import Login from './pages/login/index';
import Recover from './pages/login/recover';
import Reset from './pages/login/reset';
import NotFound from './pages/not_found';
import License from './pages/license';
import Privacy from './pages/privacy';
import Cookie from './pages/cookie';
import Profile from './pages/profile';
import Prenota from './pages/prenota';
import MiePrenotazioni from './pages/mie-prenotazioni';
import DettaglioPrenotazione from './pages/mie-prenotazioni/dettaglio';
import Admin from './pages/admin';


/** core & components */
import { LanguageProvider } from './core/language-provider';
import { LoginManager } from './core/login-manager';
import { DataManager } from './core/data-manager';
import HeaderBlock from './components/BodyElements/HeaderBlock';
import BottomNav from './components/BodyElements/BottomNav';



import { Helmet } from "react-helmet";
import { settings } from './config/settings';





/** Pagine del flusso di accesso: senza header/bottomnav. */
const AUTH_PATHS = ['/login', '/recover', '/reset'];

/** Pagine raggiungibili anche da chi non ha fatto l'accesso. */
const PUBLIC_PATHS = [...AUTH_PATHS, '/license', '/privacy', '/cookie'];


function AppContent() {

    library.add(fas)

    const [isLogged, setIsLogged] = useState(null);
    const [language, setLanguage] = useState('ita');
    const [userInfo, setUserInfo] = useState(null);
    const location = useLocation();
    const isAuthPage = AUTH_PATHS.includes(location.pathname);
    const isPublicPage = PUBLIC_PATHS.includes(location.pathname);
    const hideLayout = isAuthPage;


    useEffect(() => {
        async function init() {
            var response = await LoginManager.checkLogin()
            console.log('checkLogin', response)
            setIsLogged(response)
            setUserInfo(LoginManager.getUserInfo());
        }

        init()
        detectSidChange()
    }, []);

    async function detectSidChange() {
        var sessionId = LoginManager.registerChangeSid(async function () {
            var response = await LoginManager.checkLogin()
            console.log('CheckLogin after sid changed', response)
            setIsLogged(response);
            setUserInfo(LoginManager.getUserInfo());
        })
        console.log('--- SESSION ID ' + sessionId + ' ---')
    }


    useEffect(() => {
        LanguageProvider.setCurrentLanguage(language)
    }, [language]);


    // checkLogin ancora in corso: senza attesa la login lampeggerebbe
    // anche per chi ha una sessione valida
    if (isLogged === null) {
        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{settings.title}</title>
                </Helmet>
                <Container fluid id="main-container" className='px-0' />
            </>
        );
    }

    // senza accesso la login e' la prima pagina: le altre rimandano a lei
    // e ricordano dove si stava andando
    if (!isLogged && !isPublicPage) {
        return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    }

    /** Chi ha gia' la sessione non deve rivedere le pagine di accesso.
     * Il reset resta raggiungibile: si arriva dal link via email.
     * Il rimando usa la destinazione ricordata: subito dopo il login la
     * sessione qui non e' ancora nota e la pagina richiesta andrebbe persa. */
    const guestOnly = element => (
        isLogged ? <Navigate to={location.state?.from || '/'} replace /> : element
    );

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{settings.title}</title>
                <meta name="description" content="React application" />
            </Helmet>
            <Container fluid id="main-container" className=' px-0'>
                {!hideLayout && <HeaderBlock isLogged={isLogged} userInfo={userInfo} />}
                <div id='app-container'>
                    <Routes>
                        <Route path="*" element={<NotFound />} /> {/* 404 page */}
                        {/*
                          * La radice non e' una pagina, e' un rimando: la home
                          * era un saluto con tre scorciatoie di cui due gia'
                          * nella barra in basso e la terza verso la pagina
                          * sbagliata. Rimando e non calendario montato anche
                          * qui: cosi' ogni pagina ha un indirizzo solo e chi
                          * entra dalla radice vede accesa la voce Calendario.
                          */}
                        <Route exact path='/' element={<Navigate to='/prenota' replace />} />
                        <Route path='/license' element={<License />} />
                        <Route path='/privacy' element={<Privacy />} />
                        <Route path='/cookie' element={<Cookie />} />
                        <Route path='/prenota' element={<Prenota />} />
                        <Route path='/prenotazioni' element={<MiePrenotazioni />} />
                        <Route path='/prenotazioni/:id' element={<DettaglioPrenotazione />} />
                        <Route path='/admin/*' element={<Admin />} />
                        <Route path='/profile' element={<Profile />} />
                        <Route path='/login' element={guestOnly(<Login />)} />
                        <Route path='/recover' element={guestOnly(<Recover />)} />
                        <Route path='/reset' element={<Reset />} />
                    </Routes>
                </div>
                {!hideLayout && <BottomNav isLogged={isLogged} userInfo={userInfo} />}
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </Container>
            <VersionCheck />
        </>
    );
}

function App() {
    return (
        <Router basename={'/'}>
            <AppContent />
        </Router>
    );
}

export default App;
